module.exports = __webpack_public_path__ + "static/media/WheatStage121.5dfb63af.PNG";